import { ComponentProps } from "react";

/** WHO-5959 6b, spec S1: MDI folder-outline (Apache 2.0) for the Pro Buyer-projecten menu item. */
export const IconFolderOutlined = (props: ComponentProps<"svg">) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M20 18H4V8h16m0-2h-8l-2-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2"
    />
  </svg>
);
